export function initNav() {
  const navToggler = document.querySelector(".js-header-toggler");
  const drawer = document.querySelector(".js-header-drawer");
  const header = document.querySelector(".header");
  const backdrop = document.querySelector(".header__drawer-backdrop");

  if (!navToggler || !drawer || !header) return;

  function toggleDrawer() {
    const isOpen = header.classList.contains("drawer-open");

    navToggler.classList.toggle("active");
    header.classList.toggle("drawer-open");
    backdrop.classList.toggle("active");

    // Prevent body scroll when drawer is open
    if (!isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
  }

  function closeDrawer() {
    navToggler.classList.remove("active");
    header.classList.remove("drawer-open");
    backdrop.classList.remove("active");
    document.body.style.removeProperty("overflow");
  }

  // Toggle on button click
  navToggler.addEventListener("click", toggleDrawer);

  // Close on backdrop click
  if (backdrop) {
    backdrop.addEventListener("click", closeDrawer);
  }

  // Close when clicking any drawer link
  drawer.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeDrawer);
  });

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && header.classList.contains("drawer-open")) {
      closeDrawer();
    }
  });

  // Header glassmorphism scroll effect
  let lastScroll = 0;

  function updateHeader() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }

    lastScroll = currentScroll;
  }

  window.addEventListener("scroll", updateHeader, { passive: true });
  updateHeader(); // Initial check

  // Highlight active section in navigation
  function updateActiveLink() {
    const sections = document.querySelectorAll("section[id]");
    const drawerLinks = drawer.querySelectorAll(".header__drawer-link");

    let currentSection = "";

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;

      if (window.pageYOffset >= sectionTop - 150) {
        currentSection = section.getAttribute("id");
      }
    });

    drawerLinks.forEach((link) => {
      link.classList.remove("active");
      if (link.getAttribute("href") === `#${currentSection}`) {
        link.classList.add("active");
      }
    });
  }

  window.addEventListener("scroll", updateActiveLink, { passive: true });
  updateActiveLink(); // Initial check
}
